import styled from 'styled-components';
import { BasketOptionalPartsStyled } from '../BasketOptionalPartsStyled';

export const BasketOptionalPartsDetailsAP = styled(BasketOptionalPartsStyled)``;